import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import DeleteIcon from "@material-ui/icons/Delete";

import TextField from "../TextField";
import Button from "../Button";
import { apiRequest } from "../../utils/api";
import { useNotification } from "../../context/notification";
import Spacer from "../../utils/spacer";

import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
function ActionCheckpoint({ saveData, ...props }) {
  const { t } = useTranslation();
  const { id } = useParams();
  const history = useHistory();

  const { addNotification } = useNotification();
  const [actionCheckpointData, setActionCheckpointData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    const response = await apiRequest.get(
      `/api/getActionCheckPoint?campaign_id=${id}`
    );

    if (response.status === 200) {
      const data = response.data.data;
      setActionCheckpointData(data);
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
  }
  const handleActionChange = (value, index) => {
    let currentObj = [...actionCheckpointData];
    currentObj[index].action_checkpoint = value;
    setActionCheckpointData(currentObj);
  };
  const deleteActionCheckpoint = index => {
    let currentObj = [...actionCheckpointData];
    currentObj.splice(index, 1);
    setActionCheckpointData(currentObj);
  };

  const addActionCheckpoint = () => {
    const obj = {
      action_checkpoint: "",
    };
    setActionCheckpointData([...actionCheckpointData, obj]);
  };

  const saveActionCheckpoint = () => {
    const formData = {
      campaign_id: props.campaignId,
      user_id: props.userId,
      action_at_checkpoint: actionCheckpointData,
    };

    apiRequest
      .post(`/api/storeActionAtCheckpoint`, formData)
      .then(resp => {
        if (resp.status === 200 && resp.data.data.status) {
          const data = resp.data.data;
          addNotification(`Action checkpoint updated`, "success");
        } else {
          addNotification(t("error.internalServerError"), "error");
        }
      })
      .catch(error => {
        addNotification(`${error}`, "error");
      })
      .finally(() => {});
  };

  return (
    <div>
      <h6 className={styles.subhead}>
        {t("subjectManagement.actionAtCheckpoint")}
      </h6>
      <div className={styles.skillToImproveRow}>
        <div>
          {actionCheckpointData &&
            actionCheckpointData.map((list, index) => (
              <div key={index}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label={t("subjectManagement.enterAction")}
                  value={list.action_checkpoint}
                  onChange={e => {
                    handleActionChange(e.target.value, index);
                  }}
                />
                <DeleteIcon
                  color="action"
                  onClick={() => {
                    deleteActionCheckpoint(index);
                  }}
                />
              </div>
            ))}
          <Button
            style={{ color: "#0A859A", fontSize: "14px" }}
            onClick={addActionCheckpoint}
          >
            {" "}
            {t("subjectManagement.addAction")}
          </Button>
        </div>
        <div></div>
      </div>
      {/* <div  className={styles.skillToImproveRow}>
                <Button style={{color:'#0A859A', fontSize:'14px'}} onClick={addSkillToImprove} > Add Skill to improve</Button>
            </div> */}

      <Spacer y={6} />
      <div>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={saveActionCheckpoint}
        >
          {t("subjectManagement.saveChanges")}
        </Button>
      </div>
      <div>
        <Button
          variant="outlined"
          fullWidth
          style={{ marginTop: "10px", border: "none", color: "#757575" }}
          onClick={() => {
            history.push("/settings/subjectManagement/");
          }}
        >
          {t("subjectManagement.cancel")}
        </Button>
      </div>
    </div>
  );
}

export default ActionCheckpoint;
